import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        refCount: 0,
        isLoading: false,
        publicPath: process.env.VUE_APP_PUBLIC_PATH,
        base_url: process.env.VUE_APP_URL,
        api_key: process.env.VUE_APP_API_KEY, // SOCIB API this maybe removed from env file
        base_url_socib: process.env.VUE_APP_API_SOCIB_URL,
        data_filter_info: undefined,
        locations: [],
        selected_index: 0,
        variables: {}
    },
    mutations: {
        loading(state, isLoading) {
            if (isLoading) {
                state.refCount++
                state.isLoading = true
            } else if (state.refCount > 0) {
                state.refCount--
                state.isLoading = state.refCount > 0
            }
        },
        update_locations(state, locations) {
            state.locations = locations
        },
        update_selected_index(state, index) {
            state.selected_index = index
        },
        update_data_filter(state, data) {
            Vue.set(state, 'data_filter_info', data.data)
        },
        add_variable(state, data) {
            Vue.set(state.variables, data.key, data.value)
        }
    },
    actions: {},
    modules: {},
    getters: {
        getVariable: (state) => (key) => {
            if (state.variable[key]) return state.variable[key]
            else return undefined
        },
        getLocationByCode: (state) => (code) => {
            for (let index in state.locations) {
                let location = state.locations[index]
                if (location.location_code == code) {
                    return location
                }
            }
            return false
        },
        getGroupByCode: (state) => (location_code, group_code) => {
            for (let index in state.locations) {
                let location = state.locations[index]
                if (location.location_code == location_code) {
                    for (let i in location.camera_groups) {
                        let group = state.locations[index].camera_groups[i]
                        if (group.code == group_code) {
                            return group
                        }
                    }
                }
            }
            return false
        }
    }
})
